import { render, staticRenderFns } from "./MessageTemplateModal.vue?vue&type=template&id=444c3d30&scoped=true&"
import script from "./MessageTemplateModal.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateModal.vue?vue&type=style&index=0&id=444c3d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c3d30",
  null
  
)

export default component.exports